import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-53f9e412")
const _hoisted_1 = { class: "farming-detail-container" }
const _hoisted_2 = { class: "title-wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "item-title" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = {
  key: 0,
  class: "out-time"
}
const _hoisted_7 = { class: "product-item" }
const _hoisted_8 = { class: "right" }
const _hoisted_9 = {
  class: "farming-info",
  style: {"margin-top":"0"}
}
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "person" }
const _hoisted_12 = {
  key: 0,
  class: "video"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "info"
}
const _hoisted_15 = {
  key: 2,
  class: "learning-title"
}
const _hoisted_16 = { class: "farming-info" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "person" }
const _hoisted_19 = { class: "pop-btn-wrap" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 记录成果 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_hori_slide = _resolveComponent("hori-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, "操作开始时间：" + _toDisplayString(_ctx.farmingDetailData.optionTime || "无"), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass('status-' + _ctx.farmingDetailData.status)
            }, _toDisplayString(_ctx.farmingDetailData.status === 0
                  ? "待操作"
                  : _ctx.farmingDetailData.status === 1
                  ? "已完成"
                  : _ctx.farmingDetailData.status === 2
                  ? "已忽略"
                  : ""), 3),
            (
                _ctx.farmingDetailData.outTime > 0 && _ctx.farmingDetailData.status !== 1
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 逾期" + _toDisplayString(_ctx.farmingDetailData.outTime) + "天 ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_image, {
            class: "left",
            radius: "8px",
            src: 
              _ctx.farmingDetailData.typeImg
                ? _ctx.farmingDetailData.typeImg +
                  '?imageView2/1/w/100/h/100/rotate/0'
                : ''
            ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.preview(_ctx.farmingDetailData.typeImg || undefined)))
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_ctx.farmingDetailData.typeName || "无"), 1),
            _createElementVNode("div", null, "地块编码：" + _toDisplayString(_ctx.farmingDetailData.areaCode || "无"), 1),
            _createElementVNode("div", null, "种植面积：" + _toDisplayString(_ctx.farmingDetailData.areaArea || "0") + "亩", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.farmingDetailData.plantFarmingName || "无"), 1),
      _createElementVNode("div", _hoisted_11, " 预计人工：" + _toDisplayString(_ctx.farmingDetailData.plantFarmingArtificial || "0") + "人工/亩 ", 1),
      (_ctx.farmingDetailData.plantFarmingVideo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("video", {
              controls: "controls",
              src: _ctx.farmingDetailData.plantFarmingVideo
            }, " 您的浏览器不支持查看视频 ", 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true),
      (_ctx.farmingDetailData.plantFarmingInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.farmingDetailData.plantFarmingInfo), 1))
        : _createCommentVNode("", true),
      (
          _ctx.farmingDetailData.plantFarmingImgList &&
          _ctx.farmingDetailData.plantFarmingImgList.length > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 操作教学 "))
        : _createCommentVNode("", true),
      _createVNode(_component_hori_slide, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDetailData.plantFarmingImgList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_image, {
              key: index,
              src: item,
              radius: "5px",
              onClick: ($event: any) => (_ctx.preview(item)),
              class: "img-item"
            }, null, 8, ["src", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, "物候期：" + _toDisplayString(_ctx.farmingDetailData.phaseName || "无"), 1),
      _createElementVNode("div", _hoisted_18, "说明：" + _toDisplayString(_ctx.farmingDetailData.phaseInfo || "无"), 1),
      _createVNode(_component_hori_slide, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDetailData.phaseImgList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_image, {
              key: index,
              src: item,
              radius: "5px",
              onClick: ($event: any) => (_ctx.preview(_ctx.farmingDetailData.phaseImgList, index)),
              class: "img-item"
            }, null, 8, ["src", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: "record-text",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRecord && _ctx.onRecord(...args)))
      }, [
        _createVNode(_component_van_image, {
          src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/xiangji.png",
          class: "img"
        }),
        _hoisted_20
      ])
    ])
  ]))
}